import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
	Box,
	Button,
	Checkbox,
	FormControlLabel,
	IconButton,
	InputAdornment,
	MenuItem,
	TextField,
	Tooltip,
} from "@mui/material";
import { CREWS } from "../../straightener-common/constants";

interface Props {
	search: string;
	onSearchChange: (value: string) => void;
	productType: string;
	onProductTypeChange: (value: string) => void;
	productTypes: string[];
	crew: string;
	onCrewChange: (value: string) => void;
	withRecipe: boolean;
	onWithRecipeChange: (value: boolean) => void;
	onRefresh: () => void;
	isRefreshing: boolean;
	onAdd: () => void;
	canAdd: boolean;
}

export const StraightenerRecipesToolbar = ({
	search,
	onSearchChange,
	productType,
	onProductTypeChange,
	productTypes,
	crew,
	onCrewChange,
	withRecipe,
	onWithRecipeChange,
	onRefresh,
	isRefreshing,
	onAdd,
	canAdd,
}: Props) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
		<TextField
			size="small"
			label="Product type"
			select
			value={productType}
			onChange={(e) => onProductTypeChange(e.target.value)}
			sx={{ width: 180 }}
			slotProps={{
				inputLabel: { shrink: true },
				select: { displayEmpty: true },
			}}
		>
			<MenuItem value="">All types</MenuItem>
			{productTypes.map((t) => (
				<MenuItem key={t} value={t}>
					{t}
				</MenuItem>
			))}
		</TextField>
		<TextField
			size="small"
			label="Crew"
			select
			value={crew}
			onChange={(e) => onCrewChange(e.target.value)}
			sx={{ width: 130 }}
			slotProps={{
				inputLabel: { shrink: true },
				select: { displayEmpty: true },
			}}
		>
			<MenuItem value="">All crews</MenuItem>
			{CREWS.map((c) => (
				<MenuItem key={c} value={c}>
					Crew {c}
				</MenuItem>
			))}
		</TextField>
		<TextField
			size="small"
			placeholder="Search product..."
			value={search}
			onChange={(e) => onSearchChange(e.target.value)}
			sx={{ width: 220 }}
			slotProps={{
				input: {
					endAdornment: search ? (
						<InputAdornment position="end">
							<IconButton
								size="small"
								aria-label="clear search"
								edge="end"
								onClick={() => onSearchChange("")}
							>
								<ClearIcon fontSize="small" />
							</IconButton>
						</InputAdornment>
					) : undefined,
				},
			}}
		/>
		<FormControlLabel
			control={
				<Checkbox
					size="small"
					checked={withRecipe}
					onChange={(e) => onWithRecipeChange(e.target.checked)}
				/>
			}
			label="With recipe"
		/>
		<Tooltip title="Refresh">
			<span>
				<IconButton
					onClick={onRefresh}
					disabled={isRefreshing}
					size="small"
					sx={{
						bgcolor: "primary.main",
						color: "white",
						width: 28,
						height: 28,
						"&:hover": { bgcolor: "primary.dark" },
						"&.Mui-disabled": {
							bgcolor: "action.disabledBackground",
							color: "action.disabled",
						},
					}}
				>
					<RefreshIcon sx={{ fontSize: 18 }} />
				</IconButton>
			</span>
		</Tooltip>
		<Box sx={{ flex: 1 }} />
		{canAdd ? (
			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				CREATE RECIPE
			</Button>
		) : null}
	</Box>
);
